export const englishCrmMessages = {
  resources: {
    leads: {
      name: "Lead |||| Leads",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        name: "Name",
        company_name: "Company",
        email: "Email",
        phone: "Phone",
        title: "Title",
        source: "Source",
        source_helper: "Where this lead came from (import, website, referral...)",
        notes: "Notes",
        status: "Status",
        assignee_id: "Assignee",
        disqualify_reason: "Reason",
        last_contact_attempt_at: "Last attempt",
      },
      status: {
        new: "New",
        contacted: "Contacted",
        qualified: "Qualified",
        disqualified: "Disqualified",
      },
      action: {
        create: "Add Lead",
        mark_contacted: "Mark Contacted",
        qualify: "Qualify",
        disqualify: "Disqualify",
        move_to_leads: "Move to Leads",
        call: "Call",
        whatsapp: "WhatsApp",
        email: "Email",
      },
      converted_to: "Converted to:",
      qualified: "Lead qualified and converted.",
      moved_to_leads: "Moved to Leads.",
      empty: {
        title: "No leads found",
        description: "Raw/unqualified contact data lands here before it's promoted into a real Contact.",
      },
      activity: {
        title: "Contact attempts",
        empty: "No contact attempts logged yet.",
        how_did_it_go: "How did it go?",
        skip: "Skip",
        never: "Never contacted",
        you: "You",
        count: "%{smart_count} attempt |||| %{smart_count} attempts",
        channel: {
          call: "Call",
          whatsapp: "WhatsApp",
          email: "Email",
        },
        outcome: {
          no_answer: "No answer",
          responded: "Responded",
          wrong_number: "Wrong number",
          not_interested: "Not interested",
          callback_later: "Call back later",
        },
      },
    },
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
      filters: {
        only_mine: "Only companies I manage",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
        button: "Import CSV",
        complete:
          "Contacts import complete. Imported %{importCount} contacts, with %{errorCount} errors",
        progress:
          "Imported %{importCount} / %{rowCount} contacts, with %{errorCount} errors.",
        error:
          "Failed to import this file, please make sure your provided a valid CSV file.",
        imported: "Imported",
        remaining_time: "Estimated remaining time:",
        running: "The import is running, please do not close this tab.",
        sample_download: "Download CSV sample",
        sample_hint: "Here is a sample CSV file you can use as a template",
        stop: "Stop import",
        csv_file: "CSV File",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        noop: "Selected contacts already have this tag",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      filters: {
        show_not_interested: "Show Not Interested",
      },
      field_categories: {
        misc: "Misc",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      invalid_date: "Invalid date",
    },
    projects: {
      name: "Project |||| Projects",
      fields: {
        name: "Name",
        description: "Description",
        sales_id: "Owner",
        member_ids: "Members",
        nb_issues: "Number of issues",
        created_at: "Created at",
      },
      action: {
        create: "Create project",
        edit: "Edit project",
        new: "New Project",
        show: "Show project",
      },
      empty: {
        title: "No projects found",
        description: "It seems your project list is empty.",
      },
    },
    issues: {
      name: "Issue |||| Issues",
      fields: {
        title: "Title",
        description: "Description",
        status: "Status",
        priority: "Priority",
        assignee_id: "Assignee",
        start_date: "Start date",
        due_date: "Due date",
        project_id: "Project",
        sprint_id: "Sprint",
        milestone_id: "Milestone",
      },
      timeline: {
        empty:
          "No issues with a due date yet — the timeline needs at least one to draw an axis.",
      },
      subtasks: {
        title: "Sub-tasks",
        progress: "%{done}/%{total} done",
        add_placeholder: "Add a sub-task…",
        back_to_parent: "↑ Part of a larger issue",
      },
      action: {
        back_to_issue: "Back to issue",
        create: "Create issue",
        new: "New Issue",
      },
      updated: "Issue updated",
      empty: {
        title: "No issues found",
        description: "It seems this project has no issues yet.",
      },
    },
    sprints: {
      name: "Sprint |||| Sprints",
      empty: "No sprints yet for this project.",
      show_all: "Show all issues",
      progress: "%{done}/%{total} done",
      status: {
        planned: "Planned",
        active: "Active",
        completed: "Completed",
      },
      action: {
        new: "New Sprint",
      },
      burndown: {
        title: "Burndown",
        ideal: "Ideal",
        actual: "Actual",
        needs_dates:
          "Set a start and end date on this sprint to see a burndown chart.",
      },
    },
    milestones: {
      name: "Milestone |||| Milestones",
      empty: "No milestones yet for this project.",
      show_all: "Show all issues",
      progress: "%{done}/%{total} done",
      due: "Due",
      overdue: "Overdue",
      action: {
        new: "New Milestone",
      },
    },
    issue_notes: {
      fields: {
        text: "Comment",
        date: "Date",
        attachments: "Attachments",
      },
      action: {
        add_this: "Add this comment",
      },
      added: "Comment added",
      deleted: "Comment deleted",
      empty: "No comments yet",
      you_added: "You added a comment",
      author_added: "%{name} added a comment",
      inputs: {
        add_note: "Add a comment",
      },
      validation: {
        note_or_attachment_required: "A comment or an attachment is required",
      },
    },
    employees: {
      name: "Employee |||| Employees",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        phone: "Phone",
        employee_code: "Employee code",
        department: "Department",
        designation: "Designation",
        employment_type: "Employment type",
        status: "Status",
        date_of_joining: "Date of joining",
        date_of_leaving: "Date of leaving",
        sales_id: "CRM login",
        designation_helper: "Pick a department to narrow this list",
        date_of_birth: "Date of birth",
        address: "Address",
        emergency_contact_name: "Emergency contact name",
        emergency_contact_phone: "Emergency contact phone",
        bank_name: "Bank name",
        bank_account_name: "Account holder name",
        bank_account_number: "Account number",
        bank_ifsc: "IFSC / routing code",
        previous_employer: "Previous employer",
        previous_designation: "Previous designation",
        total_experience_years: "Years of experience",
        qualification: "Qualification",
        background: "Background",
      },
      sections: {
        basic: "Basic Info",
        employment: "Employment",
        personal: "Personal Details",
        past_employment: "Past Employment",
        bank: "Bank Details",
        background: "Background",
      },
      action: {
        create: "Create employee",
        edit: "Edit employee",
        new: "New Employee",
        show: "Show employee",
      },
      empty: {
        title: "No employees found",
        description: "It seems your employee list is empty.",
      },
    },
    leave_requests: {
      name: "Leave Request |||| Leave Requests",
      fields: {
        employee_id: "Employee",
        leave_type: "Leave type",
        from_date: "From",
        to_date: "To",
        days: "Days",
        reason: "Reason",
        status: "Status",
        approved_by: "Approved by",
        approved_at: "Approved at",
      },
      action: {
        new: "New Leave Request",
        approve: "Approve",
        reject: "Reject",
        cancel: "Cancel request",
        back: "Back",
      },
      updated: "Leave request updated",
      decided: "Leave request updated",
      cancelled: "Leave request cancelled",
      empty: {
        title: "No leave requests found",
        description: "It seems your leave request list is empty.",
      },
    },
    attendance_records: {
      name: "Attendance Record |||| Attendance",
      fields: {
        employee_id: "Employee",
        date: "Date",
        status: "Status",
        check_in: "Check in",
        check_out: "Check out",
        notes: "Notes",
      },
      action: {
        new: "Log Attendance",
        create: "Log Attendance",
      },
      empty: {
        title: "No attendance records found",
        description: "It seems your attendance log is empty.",
      },
    },
    salary_structures: {
      name: "Salary |||| Salaries",
      fields: {
        employee_id: "Employee",
        basic: "Basic",
        allowances: "Allowances",
        deductions: "Deductions",
        effective_from: "Effective from",
      },
    },
    payslips: {
      name: "Payslip |||| Payslips",
      fields: {
        employee_id: "Employee",
        month: "Month",
        year: "Year",
        basic: "Basic",
        allowances: "Allowances",
        deductions: "Deductions",
        gross_pay: "Gross pay",
        net_pay: "Net pay",
        status: "Status",
      },
      action: {
        new: "New Payslip",
        create: "Create Payslip",
        finalize: "Finalize",
      },
      finalized: "Payslip finalized",
      empty: {
        title: "No payslips found",
        description: "It seems your payslip list is empty.",
      },
    },
    transactions: {
      name: "Transaction |||| Transactions",
      fields: {
        date: "Date",
        description: "Description",
        amount: "Amount",
        category: "Category",
        balance_after: "Balance after",
        source: "Source",
        statement_import_id: "Statement",
        notes: "Notes",
        scope: "Personal/Business",
        recurring_expense_id: "Recurring expense",
      },
      action: {
        new: "Add Transaction",
        create: "Add Transaction",
      },
      empty: {
        title: "No transactions found",
        description: "It seems your transaction list is empty.",
      },
      upload: {
        button: "Upload Statement",
        title: "Upload Bank Statement",
        help: "Upload a PDF bank statement. Nothing is saved until you review and confirm below.",
        default_scope: "This statement is for:",
        mark_all_as: "Mark all as:",
        parsing: "Reading statement…",
        no_transactions: "No transactions could be found in this PDF. It may use a different layout than expected.",
        parse_error: "Couldn't read this PDF. It may not match the expected statement layout.",
        wrong_password: "That password didn't work — try again.",
        password_placeholder: "PDF password",
        unlock: "Unlock",
        summary: "%{total} transactions found. %{duplicates} look like duplicates and are unchecked by default.",
        mismatch_note: "%{count} have a balance mismatch — review before importing.",
        possible_duplicate: "Possible duplicate",
        balance_mismatch: "Balance mismatch",
        import_button: "Import %{count} transactions",
        success: "Imported %{count} transactions.",
        partial_failure: "Imported, but %{count} row(s) failed.",
      },
    },
    statement_imports: {
      name: "Statement Import |||| Statement Imports",
      fields: {
        filename: "Filename",
        period_from: "Period from",
        period_to: "Period to",
        transaction_count: "Transactions",
      },
    },
    recurring_expenses: {
      name: "Recurring Expense |||| Recurring Expenses",
      fields: {
        name: "Name",
        amount: "Amount",
        category: "Category",
        scope: "Personal/Business",
        due_day: "Due day",
        match_keyword: "Match keyword",
        active: "Active",
      },
      action: {
        create: "Add Recurring Expense",
      },
      status: {
        active: "Active",
        inactive: "Inactive",
      },
    },
    people: {
      name: "Person |||| People",
      fields: {
        name: "Name",
        phone: "Phone",
      },
      autocomplete: {
        create_item: 'Add "%{item}"',
        create_label: "Add a new person",
        create_error: "An error occurred while adding this person",
      },
    },
    loans: {
      name: "Loan |||| Loans",
      fields: {
        person_id: "Person",
        direction: "Direction",
        amount: "Amount",
        scope: "Personal/Business",
        notes: "Notes",
      },
      action: {
        add: "Add Entry",
      },
      also_log_transaction: "Also log this in Accounts (uncheck for a cash loan not through the bank)",
      transaction_link_error: "Loan saved, but couldn't also log it as a transaction — add it manually if needed.",
    },
    personal_notes: {
      name: "Note |||| Notes",
      fields: {
        title: "Title",
        content: "Content",
        color: "Color",
        tags: "Tags",
        attachments: "Attachments",
        updated_at: "Updated",
        remind_at: "Remind me",
      },
      type: {
        note: "Note",
        checklist: "Checklist",
      },
      title_placeholder: "Title",
      content_placeholder:
        "Take a note… (markdown supported: - bullets, **bold**, etc.)",
      no_color: "No color",
      edited: "Edited",
      action: {
        new: "New Note",
        pin: "Pin",
        unpin: "Unpin",
        archive: "Archive",
        unarchive: "Unarchive",
        trash: "Move to trash",
        restore: "Restore",
        history: "Version history",
        share: "Share",
        add_person: "Add person",
        clear_reminder: "Clear reminder",
      },
      tabs: {
        notes: "Notes",
        archived: "Archived",
        trash: "Trash",
      },
      pinned: "Pinned",
      others: "Others",
      reminders_due: "Reminders",
      no_versions: "No earlier versions yet.",
      version_restored: "Version restored",
      no_one_to_share: "No one else to share with",
      shared_read_only: "Shared with you — view only.",
      empty: {
        title: "No notes found",
        description: "It seems your note list is empty.",
      },
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "User |||| Users",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        administrator: "Admin",
        disabled: "Disabled",
        is_developer: "Developer",
        notes_only: "Notes Only",
        is_accounts: "Accounts",
        password_helper:
          "Share this with them directly — invite emails are unreliable on this project.",
      },
      create: {
        error: "An error occurred while creating the user.",
        success: "User created. Share their password with them directly.",
        title: "Create a new user",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "User updated successfully",
        title: "Edit %{name}",
      },
      action: {
        new: "New user",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Quixsyn CRM",
    },
    common: {
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    changelog: {
      title: "Changelog",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Quixsyn CRM",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    header: {
      import_data: "Import data",
    },
    hr: {
      my_hr: "My HR",
      leave_balance: "Leave Balance",
      no_employee_record:
        "Ask your HR admin to link your account to an employee record.",
      dashboard: {
        nav_label: "Overview",
        title: "HR Overview",
        headcount: "Headcount",
        pending_leave: "Pending Leave",
        present_today: "Present Today",
        draft_payslips: "Draft Payslips",
        pending_leave_requests: "Pending Leave Requests",
        attendance_today: "Today's Attendance",
        no_attendance_today: "No attendance recorded yet today.",
        headcount_by_department: "Headcount by Department",
        no_department: "Unassigned",
        view_employees: "View all employees",
        no_data: "Add an employee to see an overview here.",
      },
    },
    pm: {
      dashboard: {
        nav_label: "Overview",
        title: "Projects Overview",
        total_projects: "Projects",
        total_issues: "Total Issues",
        open_issues: "Open Issues",
        overdue_issues: "Overdue",
        by_status: "Issues by Status",
        by_priority: "Issues by Priority",
        no_priority_data: "No data yet.",
        workload: "Open Issues by Assignee",
        no_open_issues: "No open issues.",
        unassigned: "Unassigned",
        recent_activity: "Recent Issues",
        view_projects: "View all projects",
        no_data: "Create a project to see an overview here.",
      },
      calendar: {
        nav_label: "Calendar",
        title: "Due Date Calendar",
        today: "Today",
        more: "more",
      },
    },
    accounts: {
      nav_label: "Accounts",
      dashboard: {
        nav_label: "Overview",
        title: "Accounts Overview",
        total_income: "Total Income",
        total_expense: "Total Expense",
        net_savings: "Net Savings",
        uncategorized: "Uncategorized",
        uncategorized_hint: "%{count} transaction |||| %{count} transactions",
        monthly_trend: "Monthly Income vs Expense",
        top_categories: "Top Spending Categories",
        income_sources: "Income Sources",
        balance_trend: "Account Balance Over Time",
        recent_transactions: "Recent Transactions",
        transaction_count: "Transactions",
        avg_transaction: "Avg Transaction",
        no_data: "Import a statement to see your finances here.",
        view_transactions: "View all transactions",
        other_category: "Other",
        click_for_detail: "Click to see week-by-week detail",
        back_to_overview: "All-time overview",
        weekly_trend: "Weekly Income vs Expense",
        month_transactions: "%{count} transaction |||| %{count} transactions",
        no_expenses_this_month: "No expenses this month.",
        set_budget: "Set budget",
        invalid_budget_amount: "Enter an amount greater than 0.",
        no_data_for_scope: "No transactions in this scope yet.",
        scope_all: "All",
        recurring_this_month: "This Month's Recurring Expenses",
        recurring_posted: "Posted",
        recurring_overdue: "Overdue",
        recurring_due_day: "Due %{day}",
      },
      khatabook: {
        nav_label: "Khatabook",
        title: "Khatabook",
        no_data: "Nothing logged yet — add your first entry above.",
        owed_to_me: "Owed to me",
        i_owe: "I owe",
        settled: "Settled",
        owes_you: "Owes you %{amount}",
        you_owe: "You owe %{amount}",
        gave: "Gave",
        received: "Received",
        mark_settled: "Mark Settled",
      },
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import Data",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        stages: "Stages",
      },
      light_mode_logo: "Light Mode Logo",
      hr: {
        departments: "Departments",
        designations: "Designations",
        employment_types: "Employment Types",
        employee_statuses: "Employee Statuses",
        leave_types: "Leave Types",
        attendance_statuses: "Attendance Statuses",
      },
      accounts: {
        categories: "Categories",
        rules: "Category Rules",
        rules_help:
          "When a statement is imported, a transaction whose description contains this keyword is auto-categorized. Edit these to match real narrations.",
      },
      notes: {
        statuses: "Statuses",
      },
      projects: {
        statuses: "Issue Statuses",
        priorities: "Issue Priorities",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
        hr: "HR",
        accounts: "Accounts",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use: "Cannot remove %{display_name} that are still in use: %{items}",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
          statuses: "statuses",
          priorities: "priorities",
          departments: "departments",
          designations: "designations",
          employment_types: "employment types",
          employee_statuses: "employee statuses",
          leave_types: "leave types",
          attendance_statuses: "attendance statuses",
          transaction_categories: "transaction categories",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    preferences: {
      title: "Preferences",
      subtitle: "Customize your dashboard layout preferences.",
      theme_preset: "Theme Preset",
      fonts: "Fonts",
      page_layout: "Page Layout",
      centered: "Centered",
      full_width: "Full Width",
      navbar_behavior: "Navbar Behavior",
      sticky: "Sticky",
      scroll: "Scroll",
      sidebar_style: "Sidebar Style",
      inset: "Inset",
      sidebar: "Sidebar",
      floating: "Floating",
      sidebar_collapse_mode: "Sidebar Collapse Mode",
      icon: "Icon",
      offcanvas: "OffCanvas",
      note_corners: "Note Corners",
      rounded: "Rounded",
      square: "Square",
      restore_defaults: "Restore Defaults",
    },
    language: "Language",
    navigation: {
      label: "CRM navigation",
      groups: {
        overview: "Overview",
        crm: "CRM",
        projects: "Projects",
        hr: "HR",
        accounts: "Accounts",
        workspace: "Workspace",
      },
    },
    profile: {
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Quixsyn CRM will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
